/* ONE BOUT — <ob-hero-slider> (sections/ob-hero-slider.liquid, Sprint 2 / H1).
   Swipe (touch) and drag (mouse) come from Prestige <scroll-carousel>; this adds the Figma dots and autoplay.
   Autoplay pauses on hover / focus / touch, in a background tab, while a block is selected in the theme editor,
   and never runs for prefers-reduced-motion. */
class ObHeroSlider extends HTMLElement {
  connectedCallback() {
    // CSS keeps the heading lines unwrapped until Rift is in (no reflow jump on font swap); then normal wrapping
    const ready = () => this.classList.add('is-font-ready');
    const rift = document.fonts && document.fonts.load ? document.fonts.load('700 40px rift') : Promise.resolve();
    Promise.race([rift, new Promise((resolve) => setTimeout(resolve, 3000))]).then(ready, ready);

    this.track = this.querySelector('scroll-carousel');
    this.dots = Array.from(this.querySelectorAll('.ob-hero__dot'));
    if (!this.track || this.dots.length < 2) return;
    this.index = 0;
    this.holds = new Set();
    this.delay = (parseFloat(this.dataset.autoplay) || 0) * 1000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));
    this.track.addEventListener('carousel:change', (event) => this.mark(event.detail.index));
    this.track.addEventListener('touchstart', () => this.restart(), { passive: true });
    const hold = (key, on) => () => { on ? this.holds.add(key) : this.holds.delete(key); };
    this.addEventListener('pointerenter', hold('hover', true));
    this.addEventListener('pointerleave', hold('hover', false));
    // keyboard focus pauses (WCAG 2.2.2); a mouse click on a dot must not freeze autoplay
    this.addEventListener('focusin', (event) => { if (event.target.matches(':focus-visible')) this.holds.add('focus'); });
    this.addEventListener('focusout', hold('focus', false));
    this.addEventListener('shopify:block:select', hold('editor', true));
    this.addEventListener('shopify:block:deselect', hold('editor', false));
    this.restart();
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  mark(index) {
    this.index = index;
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
  }

  go(index) {
    this.mark(index);
    customElements.whenDefined('scroll-carousel').then(() => this.track.select(index));
  }

  restart() {
    clearInterval(this.timer);
    if (!this.delay || this.reducedMotion.matches) return;
    this.timer = setInterval(() => {
      if (this.holds.size || document.hidden) return;
      this.go((this.index + 1) % this.dots.length);
    }, this.delay);
  }
}

if (!customElements.get('ob-hero-slider')) {
  customElements.define('ob-hero-slider', ObHeroSlider);
}
